import styled from 'styled-components'

export const Hero = styled.div`
  padding: 32px;
  display: flex;
  align-items: center;

  img {
    height: 24vh;
    border-radius: 50%;
  }

  p {
    padding: 0 24px 0;
  }
`
